/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { h } from 'vue';
import { i as isFunction_1 } from '../../_chunks/dep-97c71289.mjs';
import { i as isString_1 } from '../../_chunks/dep-5f6c8826.mjs';
import { ItemsType } from '../interface.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_chunks/dep-4efc69ee.mjs';
import '../../_chunks/dep-0d1bd08c.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';
import '../../_chunks/dep-8049d2e0.mjs';

function renderCustomNode(node) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isString_1(node)) {
    return node;
  }
  if (isFunction_1(node)) {
    return node(h, params);
  }
  if (isFunction_1(node.render)) {
    return node.render(h, params);
  }
  return node;
}
function renderVNodeTNode(node, name1, name2) {
  var _node$props;
  var prop = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props[name1];
  if (prop) return prop;
  var children = node.children;
  var slot = (children === null || children === void 0 ? void 0 : children[name1]) || (children === null || children === void 0 ? void 0 : children[name2]);
  if (slot) return slot === null || slot === void 0 ? void 0 : slot();
  return null;
}
function itemTypeIsProps(itemsType, item) {
  return itemsType === ItemsType.props;
}

export { itemTypeIsProps, renderCustomNode, renderVNodeTNode };
//# sourceMappingURL=index.mjs.map
